<template>
  <div
    v-if="isDisconnected"
    class="flex items-center gap-2 mb-3 px-3 py-2 rounded-lg border border-yellow-300 dark:border-yellow-700 bg-yellow-50 dark:bg-yellow-900/30"
  >
    <fluent-icon icon="wifi-off" size="14" />
    <span class="text-sm text-slate-700 dark:text-slate-200">
      {{ $t('QUEUES_MGMT.CONNECTION.STALE') }}
    </span>
    <woot-button
      size="tiny"
      variant="smooth"
      color-scheme="secondary"
      :is-loading="isRefreshing"
      @click="$emit('refresh')"
    >
      {{ $t('QUEUES_MGMT.CONNECTION.REFRESH') }}
    </woot-button>
  </div>
</template>

<script>
import { BUS_EVENTS } from 'shared/constants/busEvents';
import BaseActionCableConnector from 'shared/helpers/BaseActionCableConnector';

export default {
  props: {
    isRefreshing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // QM §5.7 — the disconnect event may have fired before this screen was opened,
      // so seed from the connector's own flag rather than waiting for the next one.
      isDisconnected: BaseActionCableConnector.isDisconnected,
    };
  },
  mounted() {
    window.bus.$on(BUS_EVENTS.WEBSOCKET_DISCONNECT, this.onDisconnect);
    window.bus.$on(BUS_EVENTS.WEBSOCKET_RECONNECT, this.onReconnect);
  },
  beforeDestroy() {
    window.bus.$off(BUS_EVENTS.WEBSOCKET_DISCONNECT, this.onDisconnect);
    window.bus.$off(BUS_EVENTS.WEBSOCKET_RECONNECT, this.onReconnect);
  },
  methods: {
    onDisconnect() {
      this.isDisconnected = true;
    },
    // Whatever arrived while the socket was down was never pushed, so the host
    // screen has to refetch — the banner cannot know what it missed.
    onReconnect() {
      this.isDisconnected = false;
      this.$emit('refresh');
    },
  },
};
</script>
